import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
}

export enum EField {
  Header = "_header",
  Price = "price",
  Costs = "costs",
}
